module.exports = __webpack_public_path__ + "static/violence-ed58161d0c100876329610b006251cc4.png";